import React from 'react';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  return <section className="py-16 px-4 bg-surface text-center relative overflow-hidden" data-id="element-42">
      <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-mint via-transparent to-transparent" data-id="element-43" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-44">
        <FadeIn data-id="element-45">
          <h2 className="font-display text-4xl md:text-5xl font-bold text-mint mb-6" data-id="element-46">
            MEGAPACK
          </h2>

          <p className="text-xl md:text-2xl text-white/80 font-medium mb-8 leading-relaxed max-w-3xl mx-auto" data-id="element-47">
            Recursos prácticos para psicopedagogas y docentes que quieren
            trabajar mejor, con más claridad y menos improvisación. Porque
            acompañar procesos de lectoescritura no debería costarte horas extra
            todos los días.
          </p>

          <a href="#comprar" className="inline-flex items-center justify-center bg-mint hover:bg-mint/80 text-black font-bold text-xl py-5 px-10 md:px-16 rounded-xl shadow-2xl shadow-mint/10 transition-all hover:scale-105" data-id="element-48">
            💙 ¡SÍ! QUIERO ORDENAR MI TRABAJO
          </a>

          <p className="text-white/50 text-sm mt-5" data-id="element-49">
            ⚡ Acceso inmediato · 🛡️ Garantía de 7 días · 💳 Pago único
          </p>
        </FadeIn>
      </div>
    </section>;
}